var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1647846624290,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2281,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.84 318.112a124.352 124.352 0 0 1 118.4-116.096C281.952 197.472 413.12 192 512 192c98.816 0 230.016 5.472 321.76 10.016a124.352 124.352 0 0 1 118.4 116.096C956.16 378.784 960 453.44 960 512s-3.872 133.216-7.808 193.888a124.352 124.352 0 0 1-118.4 116.096C742.016 826.528 610.784 832 512 832c-98.816 0-230.016-5.472-321.792-10.016a124.352 124.352 0 0 1-118.4-116.096C67.904 645.216 64 570.56 64 512s3.872-133.216 7.84-193.888z",
    fill: "#FC0D1B",
    "p-id": 2282
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416 384v256l256-128-256-128z",
    fill: "#FFFFFF",
    "p-id": 2283
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.66f3646d.svg";
export { ForwardRef as ReactComponent };